import * as React from 'react'
import * as styles from './style/index.scss'
import SearchIcon from '@assets/img/global/search.png'
import { Picker } from 'antd-mobile'
import intl from '@utils/intl';
import { getLang } from '@src/utils'

const contactList = [
    {
        code: 'AT',
        country: 'Austria',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '(+43) (0)1 9287 666',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'BE',
        country: 'Belgium',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '02-700-73-77 (lokaal tarief) ',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'DK',
        country: 'Denmark',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+41 44 798 2222',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'FI',
        country: 'Finland',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+358 97 47 90 251 ',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'FR',
        country: 'France',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+ 33 170 381 927',
        timeTitle: 'WORK HOURS :',
        time: 'Lundi-Vendredi. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'DE',
        country: 'Germany',
        phoneTitle: 'KONTAKT:',
        phone: '0201 220 99 888',
        timeTitle: 'DIE ARBEITSZEIT :',
        time: 'Mo.-Fr. 8.00 - 18.00 Uhr'
    },
    {
        code: 'IE',
        country: 'Ireland',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '1-890-928-860 (Calls to this number are charged at local rate from a landline and have a minimum cost of €0.05. Calls from mobiles may vary.)',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'IT',
        country: 'Italy',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '(+39)02 303 10000 ',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'LUX',
        country: 'Luxembourg',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+352 2487 16 11',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'NL',
        country: 'Netherlands',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+31 204 990 153',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'NO',
        country: 'Norway',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+47 67 204501',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'PT',
        country: 'Portugal',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+351 211 227 833',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'ES',
        country: 'Spain',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+34 9179 11 799',
        timeTitle: 'WORK HOURS :',
        time: 'de 8:00h a 18:00h, de lunes a viernes'
    },
    {
        code: 'SE',
        country: 'Sweden',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+46 840 30 01 81',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 5.00 PM EST'
    },
    {
        code: 'CH',
        country: 'Switzerland',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+41 44 798 2222',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM EST'
    },
    {
        code: 'UK',
        country: 'United Kingdom',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '+44 333-777-3991 (National Rate) ',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Fri. 9.00 AM - 6.00 PM UTC'
    },
    {
        code: 'USA',
        country: 'USA',
        phoneTitle: 'CUSTOMER SERVICE:',
        phone: '1-800-426-7378, #1',
        timeTitle: 'WORK HOURS :',
        time: 'Mon-Sun. 0.00 AM - 24.00 PM EST'
    },
]
const tableAppList = [
    {
        code: 'EN',
        country: 'USA',
        contactusTitle: 'Contact US',
        contactus: 'Please contact service@lenovoconnect.com for order details and customer service.',
    },
    {
        code: 'PT',
        country: 'Portugal',
        contactusTitle: 'Contate-Nos',
        contactus: 'Entre em contato com service@lenovoconnect.com para obter detalhes do pedido e atendimento ao cliente.',
    },
    {
        code: 'ES',
        country: 'Spain',
        contactusTitle: 'Contáctenos',
        contactus: 'Póngase en contacto con service@lenovoconnect.com para obtener detalles del pedido y servicio al cliente.',
    },
    {
        code: 'IT',
        country: 'Italy',
        contactusTitle: 'Contattaci',
        contactus: 'Contattare service@lenovoconnect.com per i dettagli dell’ordine e il servizio clienti.',
    },
    {
        code: 'FR',
        country: 'France',
        contactusTitle: 'Contactez-nous',
        contactus: 'Veuillez contacter: service@lenovoconnect.com Détails de la commande et service à la clientèle.',
    },
    {
        code: 'DE',
        country: 'Germany',
        contactusTitle: 'Kontaktieren Sie uns',
        contactus: 'Bitte kontaktieren Sie service@lenovoconnect.com für Bestelldetails und Kundenservice.',
    },
]
const pickList = [
    { label: intl.formatMessage({ id: 'contact.country.AT' }), value: 'AT' },
    { label: intl.formatMessage({ id: 'contact.country.BE' }), value: 'BE' },
    { label: intl.formatMessage({ id: 'contact.country.DK' }), value: 'DK' },
    { label: intl.formatMessage({ id: 'contact.country.FI' }), value: 'FI' },
    { label: intl.formatMessage({ id: 'contact.country.FR' }), value: 'FR' },
    { label: intl.formatMessage({ id: 'contact.country.DE' }), value: 'DE' },
    { label: intl.formatMessage({ id: 'contact.country.IE' }), value: 'IE' },
    { label: intl.formatMessage({ id: 'contact.country.IT' }), value: 'IT' },
    { label: intl.formatMessage({ id: 'contact.country.LUX' }), value: 'LUX' },
    { label: intl.formatMessage({ id: 'contact.country.NL' }), value: 'NL' },
    { label: intl.formatMessage({ id: 'contact.country.NO' }), value: 'NO' },
    { label: intl.formatMessage({ id: 'contact.country.PT' }), value: 'PT' },
    { label: intl.formatMessage({ id: 'contact.country.ES' }), value: 'ES' },
    { label: intl.formatMessage({ id: 'contact.country.SE' }), value: 'SE' },
    { label: intl.formatMessage({ id: 'contact.country.CH' }), value: 'CH' },
    { label: intl.formatMessage({ id: 'contact.country.UK' }), value: 'UK' },
    { label: intl.formatMessage({ id: 'contact.country.USA' }), value: 'USA' }
]
export default class Contact extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            list: localStorage.getItem('chl') === 'tabletApp' ? tableAppList : contactList
        }
    }

    changeRegion = e => {
        const list = contactList.filter(item => item.code === e[0])
        this.setState({
            list: list
        })
    }

    render() {
        const lang = getLang().toUpperCase()
        const lanObj = this.state.list.find(val => val.code === lang) || {}
        const isTable = localStorage.getItem('chl') === 'tabletApp'
        return (
            <div className={styles.contactWrap}>
                {isTable ?
                    <>
                        {
                            <div className={styles.contactItem}>
                                <h3>{lanObj.contactusTitle}</h3>
                                <p className={styles.phone}>{lanObj.contactus}</p>
                            </div>
                        }
                    </> :
                    <>
                        <Search changeRegion={this.changeRegion} />
                        {
                            this.state.list.map((item, index) => (
                                <div className={styles.contactItem} key={index}>
                                    <h2>{intl.formatMessage({ id: `contact.country.${item.code}` })}</h2>
                                    <h3>{item.phoneTitle}</h3>
                                    <p className={styles.phone}>{intl.formatMessage({ id: `contact.phone.${item.code}` })}</p>
                                    <h3>{item.timeTitle}</h3>
                                    <p>{intl.formatMessage({ id: `contact.workHours.${item.code}` })}</p>
                                </div>
                            ))
                        }
                    </>}

            </div>
        )
    }
}

class Search extends React.Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            text: intl.formatMessage({ id: 'contact.chooseRegion.text' }),
            currentRegion: ''
        }
    }

    changeRegion = e => {
        this.setState({
            currentRegion: e[0],
            text: e[0]
        })
        this.props.changeRegion(e)
    }
    getCountryName = (value) => {
        const obj = pickList.find(item => item.value === value)
        return obj ? obj.label : ''
    }

    render() {
        return (
            <Picker
                data={pickList}
                cols={1}
                value={[this.state.currentRegion]}
                okText={intl.formatMessage({ id: 'common.sure' })}
                dismissText={intl.formatMessage({ id: 'common.cancel' })}
                onChange={this.changeRegion}
            >
                <section className={styles.searchWrap}>
                    <div className={styles.searchInnerWrap}>
                        <img src={SearchIcon} className={styles.searchIcon} />
                        <span
                            style={{ color: this.state.currentRegion ? '#4a4a4a' : '' }}>{this.getCountryName(this.state.currentRegion) || this.state.text}</span>
                    </div>
                </section>
            </Picker>
        )
    }
}
